import { render, staticRenderFns } from "./ActualLandPlanId.vue?vue&type=template&id=54f20a10&scoped=true&"
import script from "./ActualLandPlanId.vue?vue&type=script&lang=js&"
export * from "./ActualLandPlanId.vue?vue&type=script&lang=js&"
import style0 from "./ActualLandPlanId.vue?vue&type=style&index=0&id=54f20a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f20a10",
  null
  
)

export default component.exports